export default {
  oops: 'Oops!',
  validOrigin: 'Please select a valid departure location',
  validDestination: 'Please select a valid destination',
  validOutboundDate: 'Please select a valid departure date',
  validReturnDate: 'Please select a valid return date',
  validChildAges: 'Please select the ages of all children',
  oneChild: 'Only 1 child (aged 0-2) per adult is allowed',
}
